import { memo } from 'react'

import { StoreRewardItem } from '@common/models/bonus'
import { useTranslations } from 'next-intl'

import { StoreTypography } from '../../typography/StoreTypography'

import styles from './ItemDeliveryIndicator.module.scss'

type ItemsDeliveredProps = {
  unclaimedItems: StoreRewardItem[]
  tentativeItems: StoreRewardItem[]
  completedBonusTrack: boolean
}

export const ItemDeliveryIndicator = memo(({ unclaimedItems, tentativeItems }: ItemsDeliveredProps) => {
  const t = useTranslations()
  const unclaimedBonuses = unclaimedItems.length > 0 && tentativeItems.length === 0
  const bonusesDeliveredOnCheckout = [...unclaimedItems, ...tentativeItems]

  const bonusesDeliveredText = t('bonus_bonuses_delivered_on_checkout')
  const unclaimedBonusesText = t('n_bonuses_to_claim', { n: null })

  return (
    <div className={styles.deliveredItemsContainer}>
      <div className={styles.deliveredItemsCount}>
        <StoreTypography
          tag="div"
          textSize="body"
          style="plain"
          overrideFont="supercellHeadline"
          lineHeight="tight"
          className={styles.bonusCount}
        >
          {unclaimedBonuses ? unclaimedItems.length : bonusesDeliveredOnCheckout.length}
        </StoreTypography>
      </div>

      <div className={styles.deliveredTextContainer}>
        <StoreTypography
          tag="div"
          textSize="xs"
          style="plain"
          overrideFont="supercellHeadline"
          lineHeight="tight"
          className={styles.deliveredText}
        >
          {unclaimedBonuses ? unclaimedBonusesText : bonusesDeliveredText}
        </StoreTypography>
      </div>
    </div>
  )
})

ItemDeliveryIndicator.displayName = 'ItemDeliveryIndicator'
